import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getContrast } from 'polished';
import breakpoint from 'styled-components-breakpoint';

const SideBarShellEle = styled.nav`
    background-color: ${props => props.theme.global.colors.sideBarColor};
    border-right: ${props => (getContrast('#fff', props.theme.global.colors.sideBarColor) < props.theme.global.constrastThresholdsFromWhite.sideBarBorder ? props.theme.global.borders.layout : 'none')};
    overflow: auto;
    top: 70px;
    padding: 0px;
    user-select: none;
    text-decoration: none;
    font-family: ${props => props.theme.font.primary};
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

    ${breakpoint('xs', 'md')`
        position: fixed;
        z-index: 1500;
        width: 100%;
        top: 60px;
        height: ${props => (props.mobileNavExpanded ? 'calc(100vh - 60px)' : '0')};
    `}

    ${breakpoint('md', 'xl')`
        position: fixed;
        width: 200px;
        height: calc(100vh - 70px);
    `}
`;

class SideBarShell extends Component {
    render() {
        return (
            <SideBarShellEle className="hidden-print" mobileNavExpanded={this.props.mobileNavExpanded}>
                {this.props.children}
            </SideBarShellEle>
        );
    }
}

const mapStateToProps = state => ({
    mobileNavExpanded: state.layout.mobileNavExpanded
});

export default connect(mapStateToProps)(SideBarShell);



// WEBPACK FOOTER //
// ./src/components/atoms/sidebar/SideBarShell.js